import type { PropsWithChildren } from 'react';

type Props = {
  disabled?: boolean; // NOTE: show field but disabled
  isSelectable?: boolean; // NOTE: do not show field
  isSelected?: boolean;
  onSelected: (value: boolean) => void;
};

export default function SelectableListItem({
  disabled = false,
  isSelectable = false,
  isSelected = false,
  onSelected,
  children,
}: PropsWithChildren<Props>) {
  if (!isSelectable) return children;

  return (
    <div
      className='flex flex-1 cursor-pointer items-center gap-2'
      onClick={() => !disabled && onSelected(!isSelected)}>
      <input
        type='checkbox'
        disabled={disabled}
        checked={isSelected}
        readOnly
        className='checkbox-primary checkbox rounded-full border-base-200'
      />

      <div className='flex-1 pointer-events-none'>{children}</div>
    </div>
  );
}
